import { Box, Button, Grid, Modal, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import colorConfigs from "../../configs/colorConfigs";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import MaterialReactDataTable from "../../components/layout/MaterialReactDataTable";
import { AppAPiUrl, appModelPermission, appModelType } from "../../configs/appData";
import { useNavigate } from "react-router-dom";
import AxiosMain from "../../components/layout/AxiosMain";
import CloseIcon from '@mui/icons-material/Close';
import { useFormik } from "formik";
import * as Yup from 'yup';
import Swal from "sweetalert2";
import TranslationGetHOC from "../../components/layout/TranslationGetHOC";
import PaginationDropDown from "../../components/layout/PaginationDropDown";
import LoaderScreen from "../../components/layout/LoaderScreen";
import AppPermissionHOC from "../../components/layout/AppPermissionHOC";

function AdminResellerProducts(props: any) {
    const navigate = useNavigate();
    const [isAddReseller, setAddReseller] = useState(false);
    const [iComponetTranslate, setICTranslation] = useState([]);
    const [isTransLoaded, setLoaded] = useState(false);
    const [isResellerLoader, setResellerLoader] = useState(false);
    const [dependendedVal, setDependedVal] = useState<any>([]);
    const [tableDataShow, setTableDataShow] = useState([]);
    const [triggerUpdate, setTriggerUpdateData] = useState(false);
    const [openAddResellerModal, setOpenAddResellerModal] = useState(false);
    const appPermission = useSelector((state: RootState) => state.appState.appPermission);
    const { appCountry } = useSelector((state: RootState) => state.appState);

    const resellerSchema = Yup.object().shape({
        reseller: Yup.number().required('Required'),
    });

    const resellerForm = useFormik({
        initialValues: {
            reseller: "",
        },
        validationSchema: resellerSchema,
        onSubmit: (values) => {
            setResellerLoader(true);
            const apiURL = AppAPiUrl.ResellerProductsCreate;
            addReseller(apiURL, values);
        }
    });

    const addReseller = (apiURL: any, data: any) => {
        let APiValues = { ...data };
        AxiosMain.post(apiURL, APiValues).then((res) => {
            resellerForm.resetForm();
            if (res.status === 201) {
                setResellerLoader(false);
                setTriggerUpdateData(true);
                setOpenAddResellerModal(false);
            }
        }).catch((e) => {
            const { response } = e;
            if (response.status === 401) {
                Swal.fire({
                    text: response.data.detail,
                    icon: 'warning',
                });
            } else if (response.status === 400) {
                for (const [key, value] of Object.entries(response.data)) {
                    Swal.fire({
                        text: value as string,
                        icon: 'warning',
                    });
                }
            } else {
                Swal.fire({
                    text: "Something Went Wrong!",
                    icon: 'warning',
                });
            }
            setResellerLoader(false);
        });
    };

    const t = (name: string) => {
        const ifExist: any = iComponetTranslate.filter((item: any) => item.label === name);
        if (ifExist.length > 0) {
            return ifExist[0].value ? ifExist[0].value : `No translate found (${ifExist[0].label})`;
        }
        return `No key found (${name})`;
    };


    const resellerPricelistsRow = [
        {
            accessorFn: (row: any) => row.name,
            header: "Pricelist Name",
        },
        {
            accessorFn: (row: any) => row.discount_policy,
            header: "Discount Policy",
        },
        {
            accessorFn: (row: any) => row.currency,
            header: "Currency",
        },
    ];

    const cmSetTableData = (rows: any) => setTableDataShow(rows);
    const getpopDate = (row: any) => navigate(`/admin/reseller-pricelists/${row.id}`);

    useEffect(() => {
        const { translateDataft } = props;
        const newCode = appCountry.toLowerCase();
        if (translateDataft && translateDataft.hasOwnProperty(`${newCode}`)) {
            setICTranslation(translateDataft[`${newCode}`]);
            setTimeout(() => {
                setLoaded(true);
            }, 1000);
        }
        else {
            setICTranslation([]);
            setLoaded(true);
        }
    }, [props, appCountry]);


    const resetTrigger = () => {
        setTriggerUpdateData(false);
    };

    return (
        <Box sx={{ my: "20px" }}>           
            <div style={{ marginTop: "20px", marginBottom: "20px" }}>
                <MaterialReactDataTable
                    parentDependValue={dependendedVal}
                    useFor={"Reseller PriceList"}
                    apiLink={AppAPiUrl.ResellerPricelists}
                    tRow={resellerPricelistsRow}
                    clickFunc={getpopDate}
                    setTableDataShow={cmSetTableData}
                    triggerUpdate={triggerUpdate}
                    resetTrigger={resetTrigger}
                    clickFuncDataShow={true} />
            </div>
        </Box>
    );
}

function ResellerProducts({ isAllow }: any) {
    const dependency = { require: ['Sidebar'] };
    const MainComponent = TranslationGetHOC(AdminResellerProducts, "admin_reseller_pricelists", isAllow, {}, dependency);
    return isAllow ? <MainComponent /> : (<LoaderScreen msg="Loading ..." />);
}

export default AppPermissionHOC(ResellerProducts, appModelPermission.RESELLERPRODUCTS, appModelType.READ);
